module.exports = __webpack_public_path__ + "static/a3i_footer_logo-74507d55e7827417d6a1a58a0011983d.png";